<script setup>
import { ref, computed } from 'vue';
import { useFieldsStore } from '@/stores/storeFieldData';
import { useValidation } from '@/utils/useValidataion';

const storeField = useFieldsStore();

const value = defineModel();

const { validation, isValid, isTouched, textError } = useValidation(value)

const errorText = ref(null)

const heightErrorText = computed(() => {
    if (errorText.value) {
        return errorText.value.offsetHeight;
    }
})

const maskOptions = {
    mask: '+{7} (000) 000-00-00',
    lazy: false
}


const props = defineProps({    
    stateKey: {
        type: String,
    },
    placeholder: {
        type: String,
        default: ''
    }, 
    required: {
        type: Boolean,
    },   
})

function onPhoneAccept(e) {
    const maskRef = e.detail   
    value.value = maskRef.value      
    storeField.updateFields(props.stateKey, 'title', maskRef.unmaskedValue)
    // validation(props.stateKey)
    validation(props.stateKey, maskRef.unmaskedValue)
}
// npm install vue-imask
</script>
<template>
    <label :class="['input']">
        <div class="input__holder">
            <input 
                type="text"                              
                :placeholder="placeholder"
                required
                :class="['input__field', isTouched && (isValid ? 'valid' : 'not-valid')]"
                :value="value"                          
                v-imask="maskOptions"
                @accept="onPhoneAccept"        
                @blur="validation(stateKey)"    
            >
            <span class="input__title"><slot></slot></span>
        </div>
        
        <Transition>
            <span v-if="!!textError" class="input__error" ref="errorText" :style="{ bottom: `${(heightErrorText + 10) * -1}px` }">{{ textError }}</span>
        </Transition>
    </label>
</template>
<style lang='scss' scoped>
.v-enter-active,
.v-leave-active {
    transition: all 0.25s ease-out;
}

.v-enter-from{
    opacity: 0;
  transform: translate(-50%, 10px);
}
.v-leave-to {
  opacity: 0;
  transform: translate(-50%, 10px);
}
</style>